import { render } from "./FormRichText.vue?vue&type=template&id=4ca8d8a0"
import script from "./FormRichText.vue?vue&type=script&lang=js"
export * from "./FormRichText.vue?vue&type=script&lang=js"

import "./FormRichText.vue?vue&type=style&index=0&id=4ca8d8a0&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__